// extracted by mini-css-extract-plugin
module.exports = {"icon":"star-icon_icon__1I5c1","disable":"star-icon_disable__1GQ6B","on":"star-icon_on__F1Epx","sicon":"star-icon_sicon__1D0Nw","off":"star-icon_off__2Adrq"};